import React, { useMemo, useState } from "react";
import _ from "lodash";
import constants from "../../config/constants";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import CardContent from "./common/CardContent";
import HtmlInteractiveContent from "./common/HtmlInteractiveContent";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import LogsService from "../../utils/logs";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";

const HtmlInteractive = ({
  post,
  lookup,
  showPmbokModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  showShareModal,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const [expanded, setExpanded] = useState(false);

  const icons = useMemo(() => {
    return _.filter(post.referenceFiles, {
      fileKey: constants.fileKey.additionalMedia,
    });
  }, [post.referenceFiles]);

  const postData = useMemo(() => {
    try {
      return post.data ? JSON.parse(post.data) : {};
    } catch (error) {
      return {};
    }
  }, [post.data]);

  const previewOpen = _.get(postData, "showsPreview", false);

  const expand = async () => {
    if (!canProceed()) return;

    if (!expanded) {
       if (post.isPublic && post.publishUntilDate && !((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        await LogsService.logViewItem({
          contentKey: post.contentKey,
          contentSubType: post.contentType,
        })
          .then(() => { })
          .catch(() => { });
      }
    }

    setExpanded(!expanded);
  };
  const previewImage = previewImageOfPost(post);

  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList = {mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <CardSubheader
                subheader={post.title}
                showPmbokModal={showPmbokModal}
              />

              {previewImage && !expanded ? (
                <div className="relative" onClick={expand}>
                  <div className="pin absolute image-overlay">
                    <i className="absolute fas fa-plus-circle text-white text-4xl md:text-6xl cursor-pointer play-button" />
                  </div>
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              ) : (
                <>
                  {previewOpen && (
                    <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                  )}
                  <HtmlInteractiveContent
                    setExpanded={setExpanded}
                    title={postData.description}
                    sections={postData.sections}
                    icons={icons}
                  />
                </>
              )}

              <CardContent post={post} />

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              userLikes={userLikes}
              feedbacks={feedbacks}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default HtmlInteractive;
